var React = require('react');

function PhoneIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m1.0733 2.22917c.13107-.63337.62674-1.10261 1.24802-1.282466l.62489-.180898c.88381-.255855 1.82815.124292 2.2882.921124l1.01667 1.76092c.55228.95659.22453 2.17977-.73205 2.73205l-.98803.57044c-.69796.40297-1.08166 1.18715-.84633 1.95797.22375.73292.59988 1.71659 1.21896 2.78889.60308 1.0446 1.21035 1.7811 1.68591 2.2692.51825.532 1.31418.5566 1.95734.1852l1.09437-.6318c.95655-.5523 2.17975-.2245 2.73205.7321l1.0167 1.7609c.46.7968.3171 1.8047-.3464 2.4422l-.5115.4914c-.4426.4252-1.0567.6237-1.6462.4531-1.74209-.5042-5.51468-2.0621-8.07385-6.4947-2.550524-4.41765-2.122807-8.61965-1.73875-10.47563z","fill":"#333","fillRule":"evenodd"}));
}

PhoneIconInline.defaultProps = {"fill":"none","height":"20","viewBox":"0 0 14 20","width":"14"};

module.exports = PhoneIconInline;

PhoneIconInline.default = PhoneIconInline;
